import { makeStyles } from "@saleor/macaw-ui";

export const useStyles = makeStyles(
  theme => ({
    root: {
      marginTop: "24px",
      overflowX: "auto",
      width: "100%",
      border: `1px solid ${theme.palette.grey[300]}`,
      borderRadius: "2px",
      "&::-webkit-scrollbar": {
        height: "14px",
        background: "#FFFFFF"
      },
      "&::-webkit-scrollbar-track": {
        borderRadius: 10
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#CCCCCC",
        borderRadius: 10,
        border: "4px solid #FFFFFF",
        height: "6px"
      },
      "& .MuiTableBody-root": {
        "& .MuiTableCell-root": {
          padding: "1.2rem 1.2rem ",
          borderTop: `1px solid ${theme.palette.grey[300]}`,
          borderRight: `1px solid ${theme.palette.grey[300]}`
        }
      },
      "& .MuiTableHead-root": {
        "& .MuiTableCell-root": {
          padding: "1.2rem 1.2rem ",
          borderTop: `1px solid ${theme.palette.grey[300]}`,
          borderRight: `1px solid ${theme.palette.grey[300]}`
        }
      },
      "& .MuiTable-root": {
        overflowX: "auto",
        width: "100%",
        "& .MuiTableBody-root .MuiTableCell-root:first-child:not(.MuiTableCell-paddingCheckbox)": {
          textAlign: "center",

          "& svg": {
            cursor: "pointer"
          }
        }
      }
    },
    tableContainer: {
      maxHeight: "60vh"
    },
    flex: { display: "flex", alignItems: "center" },
    col1: {
      minWidth: 80,
      maxWidth: 80,
      overflowWrap: "break-word"
    },
    col2: {
      minWidth: 120,
      maxWidth: 120,
      overflowWrap: "break-word"
    },
    freeze2: {
      position: "sticky",
      left: 80,
      background: "inherit",
      zIndex: 3
    },
    freeze1: {
      position: "sticky",
      left: 0,
      background: "inherit",
      zIndex: 3
    },
    col3: {
      minWidth: 180,
      whiteSpace: "nowrap"
    },
    col4: {
      minWidth: 120
    },
    col5: {
      minWidth: 70,
      maxWidth: 70,
      "& svg": {
        width: 25
      }
    },
    col18: {
      minWidth: 180
    },
    col19: {
      minWidth: 80
    },
    col6: {
      minWidth: 348
    },
    col7: {
      minWidth: 112,
      borderRight: "none !important"
    },
    col8: {
      minWidth: 72
    },
    col9: {
      minWidth: 248
    },
    col10: {
      minWidth: 192
    },
    col11: {
      minWidth: 137
    },
    col12: {
      minWidth: 160
    },
    col13: {
      minWidth: 192
    },
    col14: {
      minWidth: 176
    },
    col15: {
      minWidth: 137
    },
    col16: {
      minWidth: 128
    },
    col17: {
      minWidth: 112
    },
    col20: {
      minWidth: 140,
      maxWidth: 140,
      borderRight: "3px solid #E0E0E0 !important",
      overflowWrap: "break-word"
    },
    freeze3: {
      position: "sticky",
      left: 200,
      background: "inherit",
      zIndex: 3
    },
    countTitle: {
      margin: "2rem 0"
    },
    noBorderRight: {
      borderRight: "none !important"
    },
    dpLink: {
      cursor: "pointer",
      color: theme.palette.info.main
    },
    paginateFooter: {
      margin: "1.7rem 0"
    },
    zIndex1: {
      zIndex: 1
    },
    disabled: {
      opacity: 0.5,
      pointerEvents: "none",
      "& path": {
        stroke: theme.palette.grey[500]
      }
    },
    marginRightHeader: {
      marginRight: "14px"
    }
  }),
  {
    name: "DeliveryReportTableCustomer"
  }
);
